import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

import './styles/theme.css';
import './styles/app.css';
import './styles/login.css';
import './styles/home.css';
import './styles/learn.css';
import './styles/courses.css';
import './styles/activities.css';
import './styles/practical.css';
import './styles/manage.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
